import React from 'react'
import { Modal, Carousel } from 'react-bootstrap'
import committee from '../images/event/Committee.jpg'
import international from '../images/event/International.jpg'
import { COLORS } from '../styles/theme'
import styled from 'styled-components'
import left from '../images/icons/left-round-icon.png'
import right from '../images/icons/right-round-icon.png'

const Committee = styled(Modal)`
.modal-content {
  border-radius: 0;
  border: 0;
  box-shadow: 0px 4px 12px ${COLORS.lightGray1};
  text-align: center;
}
.modal-header {
  border: none;
  padding: 0 16px;
}
.modal-body {
  padding: 0;
  height: 100%;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  height: 100px;
  width: 100px;
  outline: black;
  background-size: 100%, 100%;
  background-image: none;
}

.carousel-control-next-icon:after
{
  content: '>';
  font-size: 55px;
  color: navy;
}

.carousel-control-prev-icon:after {
  content: '<';
  font-size: 55px;
  color: navy;
}
`

export default function CommitteeModal({ showCommittee, setShowCommittee }) {

  return (
    
    <Committee
      show={showCommittee}
      onHide={()=>setShowCommittee(false)}
      size="xl"
      aria-labelledby="congress-bio"
      centered
    >
      <Modal.Body>
        <Carousel variant="dark">
            <Carousel.Item>
                <img
                className="d-block w-100"
                src={committee}
                alt="
                Organising Committee"
                />
            </Carousel.Item>
            <Carousel.Item>
                <img
                className="d-block w-100"
                src={international}
                alt="International Advisory Board"
                />
            </Carousel.Item>
        </Carousel>
      </Modal.Body>
    </Committee>
  )
}